module.exports = __webpack_public_path__ + "static/img/rank_220.8617f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_220.png
// module id = C+6X
// module chunks = 0